const DICTIONARIES_TYPES = {
  BAG_CONTAINERS: 'bagContainers',
  CLIENT_TAGS: 'clientTags',
  CONTAINERS: 'containers',
  REGULAR: 'regular',
  TAGS: 'tags',
  WITH_ANTI_PREFERENCES: 'withAntiPreferences',
  WITH_POSITION: 'withPosition',
  WITH_POSITION_AND_ANTI_PREFERENCES: 'withPositionAndAntiPreferences',
};

export default DICTIONARIES_TYPES;
